"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentShiftTableStats = void 0;
exports.shiftToStatSlot = shiftToStatSlot;
exports.calcStatsForSlotsListSummaryWeeklyMonthlyCustom = calcStatsForSlotsListSummaryWeeklyMonthlyCustom;
exports.calcSlotStatsSummaryWeeklyMonthlyCustom = calcSlotStatsSummaryWeeklyMonthlyCustom;
exports.slotStatsSendableToShiftStats = slotStatsSendableToShiftStats;
exports.calcCellStatsFromDiff = calcCellStatsFromDiff;
const shift_1 = require("../model/v1/shift");
const employmentShiftTableStatsMap_1 = require("./employmentShiftTableStatsMap");
const shiftStats_1 = require("../stats/shiftStats");
const table_1 = require("../table/v1/table");
const common_1 = require("../js/common");
const stats_1 = require("../stats/stats");
const models_1 = require("../js/models");
const periodTypes_1 = __importDefault(require("../table/v1/periodTypes"));
const section_1 = require("../model/v1/section");
const shiftCellStats_1 = require("../stats/shiftCellStats");
const shiftRowStats_1 = require("../stats/shiftRowStats");
const shiftColumnStats_1 = require("../stats/shiftColumnStats");
class EmploymentShiftTableStats {
    roleStore;
    employmentStore;
    slotStore;
    spotWorkerStats = { column: {} };
    meStore;
    dates = [];
    statsMap;
    period;
    localTimeZone;
    useSectionWage = false;
    overtimeStartTimeHours = undefined;
    // Only count stats for the first period of a multi-period slot.
    // Should be true for day period to match production.
    onlyCountFirstPeriod = false;
    // Only count the role for the first period of a multi-period slot.
    // Should be true for day period to match production.
    onlyCountFirstRole = false;
    // Only count transport costs for the first period of a multi-period slot.
    // Should be true for all periods to match production.
    onlyCountFirstTransport = true;
    // Do not count Rest time if period is hourly.
    // Should be true for hour period to match production.
    shouldIgnoreRestField = false;
    // Toggle for ignoring labor hours if a shift is Hide to.
    // True for monthly. False for daily.
    ignoreHideToLaborHours = false;
    constructor(roleStore, employmentStore, slotStore, meStore, dates, period, localTimeZone, options) {
        this.roleStore = roleStore;
        this.employmentStore = employmentStore;
        this.slotStore = slotStore;
        this.meStore = meStore;
        const employments = employmentStore.query({ branchId: meStore.getActiveBranchId() });
        const slots = slotStore.query({ startDateMin: dates[0]?.getDate(), startDateMax: dates[dates.length - 1]?.getEnd() });
        slots.sort((a, b) => a.getStartDate() < b.getStartDate() ? 1 : -1);
        this.period = period;
        this.localTimeZone = localTimeZone;
        if (options) {
            if (typeof options.onlyCountFirstPeriod == "boolean") {
                this.onlyCountFirstPeriod = options.onlyCountFirstPeriod;
            }
            if (typeof options.onlyCountFirstRole == "boolean") {
                this.onlyCountFirstRole = options.onlyCountFirstRole;
            }
            if (typeof options.onlyCountFirstTransport == "boolean") {
                this.onlyCountFirstTransport = options.onlyCountFirstTransport;
            }
            if (typeof options.shouldIgnoreRest == "boolean") {
                this.shouldIgnoreRestField = options.shouldIgnoreRest;
            }
            if (typeof options?.ignoreHideToLaborHours == "boolean") {
                this.ignoreHideToLaborHours = options.ignoreHideToLaborHours;
            }
            if (typeof options?.useSectionWage == "boolean") {
                this.useSectionWage = options.useSectionWage;
            }
            if (typeof options?.overtimeStartTimeHours == "number") {
                this.overtimeStartTimeHours = options.overtimeStartTimeHours;
            }
        }
        this.dates = dates;
        this.statsMap = new employmentShiftTableStatsMap_1.EmploymentShiftTableStatsMap(dates, employments, slots);
    }
    // Spotworker **Start**
    getSpotWorkStats() {
        return this.spotWorkerStats;
    }
    handleSpotShiftChange(statsDiff) {
        const stats = this.spotWorkerStats.column[statsDiff.dateKey];
        // diff is only delete for now
        if (!stats) {
            return;
        }
        stats.laborCost += statsDiff.laborCost;
        stats.laborHours += statsDiff.laborHours;
        stats.numOfWorkers += statsDiff.numOfWorkers;
        stats.totalCost += statsDiff.totalCost;
        const result = {};
        for (const key of new Set([...Object.keys(stats.roleCounts), ...Object.keys(statsDiff.roleCounts)])) {
            result[key] = (stats.roleCounts[key] ?? 0) + (statsDiff.roleCounts[key] ?? 0);
        }
        stats.roleCounts = result;
    }
    addSummaryStatsToSpotWorkStats(stats) {
        this.spotWorkerStats = stats;
        this.dates.forEach(d => {
            const spotColumnStats = this.spotWorkerStats.column[d.index()];
            const summaryColumnStats = this.getColumnStats(d.index())?.getData();
            if (spotColumnStats && summaryColumnStats) {
                spotColumnStats.transportCost = 0; // always 0
                spotColumnStats.laborHours = spotColumnStats.laborHours + summaryColumnStats.laborHours;
                spotColumnStats.numOfWorkers = (spotColumnStats.numOfWorkers + summaryColumnStats.numOfWorkers);
                spotColumnStats.totalCost = spotColumnStats.totalCost + summaryColumnStats.totalCost;
                spotColumnStats.laborCost = spotColumnStats.laborCost + summaryColumnStats.laborCost;
                spotColumnStats.otLaborHours = spotColumnStats.otLaborHours + summaryColumnStats.otLaborHours;
                spotColumnStats.otLaborCost = spotColumnStats.otLaborCost + summaryColumnStats.otLaborCost;
                const result = {};
                for (const key of new Set([...Object.keys(spotColumnStats.roleCounts), ...Object.keys(summaryColumnStats.roleCounts)])) {
                    result[key] = (spotColumnStats.roleCounts[key] ?? 0) + (summaryColumnStats.roleCounts[key] ?? 0);
                }
                spotColumnStats.roleCounts = result;
                const orRoleCounts = {};
                for (const key of new Set([...Object.keys(spotColumnStats.orRoleCounts), ...Object.keys(summaryColumnStats.orRoleCounts)])) {
                    orRoleCounts[key] = (spotColumnStats.orRoleCounts[key] ?? 0) + (summaryColumnStats.orRoleCounts[key] ?? 0);
                }
                spotColumnStats.orRoleCounts = orRoleCounts;
                const roleSectionCounts = {};
                for (const key of new Set([...Object.keys(spotColumnStats.roleSectionCounts), ...Object.keys(summaryColumnStats.roleSectionCounts)])) {
                    roleSectionCounts[key] = (spotColumnStats.roleSectionCounts[key] ?? 0) + (summaryColumnStats.roleSectionCounts[key] ?? 0);
                }
                spotColumnStats.roleSectionCounts = roleSectionCounts;
            }
        });
    }
    addShiftChangeToSpotWorkStats(dateKey, statsDiff) {
        const colStat = this.spotWorkerStats.column[dateKey];
        if (!colStat) {
            return;
        }
        colStat.transportCost += statsDiff.transportCost;
        colStat.laborCost += statsDiff.laborCost;
        colStat.laborHours += statsDiff.laborHours;
        colStat.totalCost += statsDiff.laborCost + statsDiff.transportCost;
        colStat.numOfWorkers += statsDiff.numOfWorkers;
        colStat.otLaborHours += statsDiff.otLaborHours;
        colStat.otLaborCost += statsDiff.otLaborCost;
        const roleCounts = {};
        for (const key of new Set([...Object.keys(colStat.roleCounts), ...Object.keys(statsDiff.roleCounts)])) {
            roleCounts[key] = (colStat.roleCounts[key] ?? 0) + (statsDiff.roleCounts[key] ?? 0);
        }
        colStat.roleCounts = roleCounts;
        const orRoleCounts = {};
        for (const key of new Set([...Object.keys(colStat.orRoleCounts), ...Object.keys(statsDiff.orRoleCounts)])) {
            orRoleCounts[key] = (colStat.orRoleCounts[key] ?? 0) + (statsDiff.orRoleCounts[key] ?? 0);
        }
        colStat.orRoleCounts = orRoleCounts;
        const roleSectionCounts = {};
        for (const key of new Set([...Object.keys(colStat.roleSectionCounts), ...Object.keys(statsDiff.roleSectionCounts)])) {
            roleSectionCounts[key] = (colStat.roleSectionCounts[key] ?? 0) + (statsDiff.roleSectionCounts[key] ?? 0);
        }
        colStat.roleSectionCounts = roleSectionCounts;
    }
    getSpotWorkColumnStats(d) {
        return this.spotWorkerStats.column[d];
    }
    // Spotworker **END**
    getColumnStats(d) {
        return this.getStatsMap().getColumnStats(d);
    }
    getRowStats(u) {
        return this.getStatsMap().getRowStats(u);
    }
    getStatsMap() {
        return this.statsMap;
    }
    handleShiftChange(shift, options) {
        const viewFrom = this.dates[0]?.getDate();
        if (!viewFrom) {
            return;
        }
        const slotEnd = shift.getEndDate();
        // Since work hours may have changed after an edit, we get the maximum To time between slot and previous version.
        let maxSlotEnd = slotEnd.valueOf();
        let prevSlotEnd;
        if (options?.prevShift) {
            prevSlotEnd = options.prevShift.getEndDate();
            maxSlotEnd = Math.max(slotEnd.valueOf(), prevSlotEnd.valueOf());
        }
        const maxSlotEndDate = new Date(maxSlotEnd);
        let slotStart = new Date(shift.getStartDate());
        try {
            slotStart = (0, table_1.truncate)(slotStart, this.period, this.localTimeZone);
        }
        catch (err) {
            alert(err);
        }
        // Since work hours may have changed after an edit, we get the minimum From time between slot and previous version.
        let minSlotStart = slotStart.valueOf();
        let prevSlotStart;
        if (options?.prevShift) {
            prevSlotStart = options.prevShift.getStartDate();
            minSlotStart = Math.min(slotStart.valueOf(), prevSlotStart.valueOf());
        }
        let minStart = new Date(minSlotStart);
        try {
            minStart = (0, table_1.truncate)(minStart, this.period, this.localTimeZone);
        }
        catch (err) {
            alert(err);
        }
        if (minStart < viewFrom) {
            minStart = viewFrom;
        }
        const viewTo = this.dates[this.dates.length - 1];
        if (!viewTo) {
            return;
        }
        let hasCountedFirstPeriodOfNewSlot = false;
        // Loop for each cell period of the slot, calculate and set new stats, pass up diffs, and send to column
        while (minStart < maxSlotEndDate && minStart <= viewTo.getDate()) { // If the slot extends beyond the view time, then break from the loop
            const date = (0, table_1.makeTableDate)(minStart, this.period, this.localTimeZone);
            // As we are calculating diffs for full period range of current and previous version of shift, this is a required flag to know if we performing diff or simply delete behavior for the current period.
            const isNewSlotOverlapping = (0, common_1.timespansOverlap)(shift.getStartDate(), shift.getEndDate(), date.getDate(), date.getEnd());
            const employments = this.employmentStore.query({ userId: shift.getUserId(), branchId: shift.getBranchId() });
            const employment = employments[0];
            // If we cannot find an employment, then we will be unable to interact with the stats map. Return.
            if (!employment) {
                return;
            }
            const start = date.getDate();
            let end = date.getEnd();
            // If we are counting stats for the entire shift and applying them to only the starting period, then use shift dates as period dates.
            if (this.onlyCountFirstPeriod && !options?.countAllPeriods) {
                end = shift.getEndDate();
            }
            const role = this.roleStore.byId(shift.getRoleId());
            let prevRole;
            if (options?.prevShift) {
                prevRole = this.roleStore.byId(options.prevShift.getRoleId());
            }
            // To mirror current production behavior, only count the first period.
            // Can remove and count stats of slots that extend into multiple cells on monthly, weekly, custom.
            const ignoreRole = this.onlyCountFirstRole && hasCountedFirstPeriodOfNewSlot;
            // For linked slots, we must ignore rest for any period other than the first even if the main setting says to not ignore rest fields.
            const ignoreRestFieldOverride = options?.applyRestFieldToFirstPeriodOnly == true && hasCountedFirstPeriodOfNewSlot;
            // For linked slots, we must ignore any rest sections on the morning shift if
            const isOvernightMorningShift = shift.isOvernightMorningShift(start) && (!shift.isMergedShift());
            const ignoreRestSections = (ignoreRestFieldOverride || isOvernightMorningShift) && shift.getRest() > 0;
            const ignoreRestField = this.shouldIgnoreRestField || ignoreRestFieldOverride || isOvernightMorningShift;
            const ignoreTransport = hasCountedFirstPeriodOfNewSlot && this.onlyCountFirstTransport && isNewSlotOverlapping;
            const calcOptions = new stats_1.CalcShiftOptions();
            calcOptions.hourlyWage = shift.getWage();
            calcOptions.ignoreRestField = ignoreRestField;
            calcOptions.ignoreRestSections = ignoreRestSections;
            calcOptions.ignoreRole = ignoreRole;
            calcOptions.ignoreTransport = ignoreTransport;
            calcOptions.ignoreLaborHours = shift.isHideTo() && this.ignoreHideToLaborHours;
            calcOptions.useSectionWage = this.useSectionWage;
            let PTOHours = 0;
            if (this.period === periodTypes_1.default.DAY) {
                switch (shift.getType()) {
                    case models_1.SLOT_TYPES.HALF_PTO:
                    case models_1.SLOT_TYPES.KOT_HALF_PTO_AM:
                    case models_1.SLOT_TYPES.KOT_HALF_PTO_PM:
                        PTOHours = 4;
                        break;
                    case models_1.SLOT_TYPES.PTO:
                    case models_1.SLOT_TYPES.KOT_PTO:
                        PTOHours = 8;
                        break;
                }
            }
            calcOptions.ptoHours = PTOHours;
            let newStats = (0, stats_1.calcShiftStats)(shift, start, end, calcOptions);
            // If change is a slot deletion, then new stats are all zeroes
            // To mirror current production behavior, only count the first period in certain contexts.
            // Can remove and count stats of slots that extend into multiple cells on monthly, weekly, custom.
            const ignoreAllStatsForPeriod = this.onlyCountFirstPeriod && hasCountedFirstPeriodOfNewSlot && !options?.countAllPeriods;
            if (options?.isDelete || ignoreAllStatsForPeriod) {
                newStats = new shiftStats_1.ShiftStats();
            }
            // The id we use for stats may have changed in the case of a shift changing from overnight to normal, for example.
            // Prefer the previous version stats id in params to calc diffs correctly.
            let prevId = options?.prevShift?.getStatsId();
            if (!prevId) {
                prevId = shift.getStatsId();
            }
            const prevStats = this.getStatsMap().getCellStats(date.index(), employment.index())?.getSlotStats(prevId);
            let statsDiff = (0, stats_1.calcSlotDiff)(newStats, prevStats);
            this.getStatsMap().getCellStats(date.index(), employment.index())?.setSlotStats(shift.getStatsId(), newStats);
            const prevCellStats = this.getStatsMap().getCellStats(date.index(), employment.index());
            // To keep Or Role implementation details out of stats calculation functions, build options here.
            const opt = {
                overtimeStartTimeHours: this.overtimeStartTimeHours,
                roles: {
                    cur: {
                        role: role,
                    },
                    prev: {
                        role: prevRole,
                    }
                }
            };
            if (role && !role.isStandardRole() && opt.roles?.cur) {
                const r = role;
                opt.roles.cur.mainRoleId = r.getMainRoleId();
            }
            if (prevRole && !prevRole.isStandardRole() && opt.roles?.prev) {
                const r = prevRole;
                opt.roles.prev.mainRoleId = r.getMainRoleId();
            }
            const newCellStatsData = (0, stats_1.calcCellStatsData)(statsDiff, prevCellStats?.getData(), opt);
            // calcCellStatsData's running-total OT formula is designed for initial load (each shift
            // added fresh from a zero base). For edits/deletes, statsDiff is a delta over an existing
            // slot, so the formula produces wrong OT hours/cost. Recompute from all per-slot stats in
            // the cell, which are always up-to-date after setSlotStats above.
            if (this.overtimeStartTimeHours != null && this.overtimeStartTimeHours > 0) {
                const threshold = this.overtimeStartTimeHours;
                const shiftsForOt = [];
                for (const id in prevCellStats?.shifts) {
                    const shift = this.slotStore.byId(id);
                    const stats = prevCellStats.shifts[id];
                    if (!stats) {
                        continue;
                    }
                    if (shift && stats.laborHours > 0)
                        shiftsForOt.push({ shift, stats });
                }
                shiftsForOt.sort((a, b) => a.shift.getStartDate() < b.shift.getStartDate() ? -1 : 1);
                let runningHours = 0;
                let otHours = 0;
                let otCost = 0;
                const periodStart = date.getDate();
                for (const { shift, stats } of shiftsForOt) {
                    // When splitNightShift is enabled (onlyCountFirstPeriod=false), OT is attributed
                    // entirely to the starting day using the shift's total hours. Continuation days
                    // (where the shift started before this period) contribute 0 to OT.
                    let otHoursForShift = stats.laborHours;
                    if (!this.onlyCountFirstPeriod) {
                        if (shift.getStartDate() < periodStart) {
                            otHoursForShift = 0;
                        }
                        else {
                            const totalOpts = new stats_1.CalcShiftOptions();
                            totalOpts.hourlyWage = shift.getWage();
                            totalOpts.useSectionWage = this.useSectionWage;
                            totalOpts.ignoreLaborHours = shift.isHideTo() && this.ignoreHideToLaborHours;
                            otHoursForShift = (0, stats_1.calcShiftStats)(shift, shift.getStartDate(), shift.getEndDate(), totalOpts).laborHours;
                        }
                    }
                    const shiftOtHours = Math.max(0, runningHours + otHoursForShift - threshold) - Math.max(0, runningHours - threshold);
                    otHours += shiftOtHours;
                    if (stats.laborHours > 0) {
                        otCost += shiftOtHours / stats.laborHours * stats.laborCost;
                    }
                    // Continuation-day overflow hours are excluded from OT quota — don't count them toward runningHours.
                    const isContinuationDay = !this.onlyCountFirstPeriod && shift.getStartDate() < periodStart;
                    if (!isContinuationDay) {
                        runningHours += stats.laborHours;
                    }
                }
                newCellStatsData.setOtLaborHours(otHours);
                newCellStatsData.setOtLaborCost(otCost);
            }
            const transportCost = employment.getTransportCost();
            statsDiff = (0, stats_1.calcCellDiff)(prevCellStats?.getData() ?? new shiftCellStats_1.ShiftCellStats(), newCellStatsData, transportCost);
            this.getStatsMap().getCellStats(date.index(), employment.index())?.setData(newCellStatsData);
            const prevRowStats = this.getStatsMap().getRowStats(employment.index())?.getData();
            const rowStats = (0, stats_1.calcRowStatsFromDiff)(statsDiff, prevRowStats ?? new shiftRowStats_1.ShiftRowStats());
            this.getStatsMap().getRowStats(employment.index())?.setData(rowStats);
            const prevColumnStats = this.getStatsMap().getColumnStats(date.index())?.getData();
            const columnStats = (0, stats_1.calcColumnStatsFromDiff)(statsDiff, prevColumnStats ?? new shiftColumnStats_1.ShiftColumnStats());
            this.getStatsMap().getColumnStats(date.index())?.setData(columnStats);
            this.addShiftChangeToSpotWorkStats(date.index(), statsDiff);
            // If counted the first period of new slot, then flip flag.
            if (!hasCountedFirstPeriodOfNewSlot && isNewSlotOverlapping) {
                hasCountedFirstPeriodOfNewSlot = true;
            }
            // Prepare for next loop
            minStart = new Date(date.getEnd());
            minStart.setMilliseconds(minStart.getMilliseconds() + 1);
        }
    }
}
exports.EmploymentShiftTableStats = EmploymentShiftTableStats;
// statsSlotToShift computes a Shift used for slot stats computation. Shift is incomplete so should not be relied on for other work.
function statsSlotToShift(s) {
    const sections = [];
    for (const sec of s.sections) {
        sections.push(statsSectionToSection(sec, s.id));
    }
    const req = {
        id: s.id,
        type: s.type,
        startDate: new Date(s.start),
        endDate: new Date(s.end),
        // The returned shift is only used to compute slot stats, so these values are empty.
        userId: 0,
        branchId: 0,
    };
    const opt = {
        hideTo: s.isHideTo,
        wage: s.wage,
        roleId: s.roleId,
        sections: sections,
        rest: s.rest,
    };
    return new shift_1.Shift(req, opt);
}
// statsSlotToShift computes a Section used for slot stats computation. Section is incomplete so should not be relied on for other work.
function statsSectionToSection(s, parentId) {
    const req = {
        id: s.id,
        type: s.type,
        startDate: new Date(s.start),
        endDate: new Date(s.end),
        // The returned section is only used to compute slot stats, so these values are empty.
        userId: 0,
        branchId: 0,
    };
    const opt = {
        wage: s.wage,
        roleId: s.roleId,
    };
    return new section_1.Section(parentId, req, opt);
}
function shiftToStatSlot(s) {
    const sections = [];
    for (const section of s.getSections()) {
        sections.push(sectionToStatsSection(section));
    }
    return {
        id: s.getOriginalId(),
        feId: s.getId(),
        wage: s.getWage(),
        isHideTo: s.isHideTo(),
        type: s.getType(),
        roleId: s.getOriginalRoleId(),
        sections,
        start: s.getStartDate().toISOString(),
        end: s.getEndDate().toISOString(),
        rest: s.getRest(),
    };
}
function sectionToStatsSection(s) {
    return {
        id: s.getOriginalId(),
        wage: s.getWage(),
        type: s.getType(),
        roleId: s.getOriginalRoleId(),
        start: s.getStartDate().toISOString(),
        end: s.getEndDate().toISOString(),
    };
}
// Cannot support split night shift nor linked slots.
function calcStatsForSlotsListSummaryWeeklyMonthlyCustom(slots, useSectionWage) {
    // Important. Out order should be the same as input order.
    const out = [];
    for (const s of slots) {
        const stats = calcSlotStatsSummaryWeeklyMonthlyCustom(s, useSectionWage);
        out.push({
            id: s.id,
            feId: s.feId,
            isWorkerNumberCounted: stats.isWorkerNumberCounted,
            isCountedInTransportCost: stats.isCountedInTransportCost,
            laborHours: stats.laborHours,
            laborCost: stats.laborCost,
            roleId: stats.getRoleId(),
            roleSectionIds: stats.getRolesectionIds(),
            type: stats.type,
        });
    }
    return out;
}
// Cannot support split night shift nor linked slots.
function calcSlotStatsSummaryWeeklyMonthlyCustom(slot, useSectionWage) {
    const calcOptions = new stats_1.CalcShiftOptions();
    calcOptions.hourlyWage = slot.wage;
    calcOptions.ignoreLaborHours = slot.isHideTo;
    calcOptions.useSectionWage = useSectionWage || false;
    return (0, stats_1.calcShiftStats)(statsSlotToShift(slot), new Date(slot.start), new Date(slot.end), calcOptions);
}
function slotStatsSendableToShiftStats(ss) {
    const shiftStats = new shiftStats_1.ShiftStats();
    shiftStats.setLaborHours(ss.laborHours);
    shiftStats.setLaborCost(ss.laborCost);
    shiftStats.setIsWorkerNumberCounted(ss.isWorkerNumberCounted);
    shiftStats.setRoleId(ss.roleId);
    for (const id of ss.roleSectionIds) {
        shiftStats.setRoleSectionId(id);
    }
    shiftStats.setTransportCost(ss.isCountedInTransportCost);
    shiftStats.setType(ss.type);
    return shiftStats;
}
function calcCellStatsFromDiff(slotStatsDiff, prevStats, role, overtimeStartTimeHours) {
    // To keep Or Role implementation details out of stats calculation functions, build options here.
    const opt = {
        overtimeStartTimeHours,
        roles: {
            cur: {
                role: role,
            },
        }
    };
    if (role && !role.isStandardRole() && opt.roles?.cur) {
        const r = role;
        opt.roles.cur.mainRoleId = r.getMainRoleId();
    }
    return (0, stats_1.calcCellStatsData)(slotStatsDiff, prevStats, opt);
}
